﻿import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'moment' })
export class MomentPipe implements PipeTransform {
    // added 3rd arg for support to call this from a typescript class
    transform(input: Date, momentFn: string, formattingString?: string): string {
        if (!input)
            return '';
        var args = Array.prototype.slice.call(arguments, 2);
        var utcDateTime = moment.utc(input);
        var momentObj = utcDateTime.local();
        return momentObj[momentFn].apply(momentObj, args);
    }
}


// @Pipe({ name: 'momentUtc' })
// export class MomentUtcPipe implements PipeTransform {
//     transform(input: Date, momentFn: string): string {
//         if (!input)
//             return '';

//         var args = Array.prototype.slice.call(arguments, 2);
//         var utcDateTime = moment.utc(input);
//         return utcDateTime[momentFn].apply(utcDateTime, args);
//     }
// }


@Pipe({ name: 'formatDate' })
export class FormatDatePipe implements PipeTransform {
    transform(value: string): any {
        if (value == '' || value == undefined)
            return '';

        var dateValue = new Date(value);
        var datewithouttimezone = new Date(dateValue.getUTCFullYear(),
            dateValue.getUTCMonth(),
            dateValue.getUTCDate(),
            dateValue.getUTCHours(),
            dateValue.getUTCMinutes(),
            dateValue.getUTCSeconds());
        return datewithouttimezone;
    }

}
